import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JanelaEnvioProtocolo } from 'src/app/model/protocolo-arquivo.model';
import { JanelaSolicitacaoHonraService } from './janela-solicitacao-honra.service';

@Injectable({ providedIn: 'root'})
export class JanelaSolicitacaoHonraResolver implements Resolve<Observable<JanelaEnvioProtocolo>> {

    constructor(
        private service: JanelaSolicitacaoHonraService,
        private bnAlertsService: BnAlertsService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<JanelaEnvioProtocolo>  {
    
     return this.service.getJanelaEnvioDoMesAtual()
      .pipe(
        catchError(error => {
            console.error('Nao foi possivel obter dados para a janela corrente de solicitações de honra.');
            this.bnAlertsService.alertaErro('Erro', `Não foi possível encontrar dados de janela de envio para este mês. Entrar em contato com a equipe de TI.`);      
            return of(null);
        }));
      }
}
